import React, { createContext, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap styles are imported
const GlobalErrorContext = createContext();

export const GlobalErrorProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const showErrorModal = (message) => {
    setErrorMessage(message);
    setShowError(true);
  };

  const hideErrorModal = () => {
    setErrorMessage('');
    setShowError(false);
  };

  return (
    <GlobalErrorContext.Provider value={{ showErrorModal, hideErrorModal }}>
      {children}
      {showError && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" > {/* Apply alert-danger class */}
              <div className="modal-header" style={{ backgroundColor: '#e2520f', color: 'white' }}>
                <h5 className="modal-title">Error</h5>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={hideErrorModal}
                  aria-label="Close"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <i className="bi bi-exclamation-circle-fill" style={{ fontSize: '1.5rem', color: 'white' }}></i> {/* Error icon */}
                </button>
              </div>
              <div className="modal-body">
                <p>{errorMessage}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={hideErrorModal}
                  style={{ backgroundColor: '#e2520f', color: 'white', borderColor: '#CC6843' }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalErrorContext.Provider>
  );
};

export const useGlobalError = () => useContext(GlobalErrorContext);